import * as React from "react";
import Highlighter from "react-highlight-words";
import { SGBSColor } from "../../common/common.typings";

export interface HighlightProps {
  /**
   * this dictates input text
   */
  text: string;
  /**
   * this dictates term to highlight
   * @default []
   */
  term?: string[];

  /**
   * the color of text in highlighted span element.
   * will be appended by text-${color}
   * Be aware this will be overridden by  highlightClassName property if it's defined
   * @default secondary
   */
  color?: SGBSColor;

  /**
   * a class to apply only to the highlighted span element
   * Be aware this will override the color property
   */
  highlightClassName?: string;

  /**
   * className to apply to the container. The span element
   *
   */
  className?: string;
}

const Highlight: React.FunctionComponent<HighlightProps> = ({
  text = "",
  term = [],
  color = "secondary",
  highlightClassName,
  className = "",
}: HighlightProps) => {
  const highlightClassNameToApply = highlightClassName ? highlightClassName : `text-${color}`;
  return (
    <Highlighter
      highlightClassName={highlightClassNameToApply}
      searchWords={term}
      textToHighlight={text}
      highlightTag={"span"}
      autoEscape={true}
      className={className}
    />
  );
};

export default Highlight;
